import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { TipoDescuento } from '../models/tipo-descuento.model';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class TiposDescuentoService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getTiposDescuento(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/calculadora/tipos-descuento';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<TipoDescuento[]>(url, { headers, observe: 'response', params });
    }

    getTipoDescuentoById(id: number) {
        return this.http.get<TipoDescuento>(`/calculadora/tipos-descuento/${id}`);
    }

    createTipoDescuento(tipoDescuento: TipoDescuento) {
        return this.http.post<TipoDescuento>('/calculadora/tipos-descuento', tipoDescuento);
    }

    updateTipoDescuento(tipoDescuento: TipoDescuento) {
        return this.http.put<TipoDescuento>(`/calculadora/tipos-descuento/${tipoDescuento.id}`, tipoDescuento);
    }

    deleteTipoDescuento(id: number) {
        return this.http.delete<TipoDescuento>(`/calculadora/tipos-descuento/${id}`);
    }
}
